import { useQuery } from "@tanstack/react-query";
import { DEALS_CART_CACHE_CONFIG, DEALS_CART_QUERY_KEY } from "@/features/deals/constants/dealsCart.constants";
import { dealsCartService } from "@/features/deals/services/dealsCart.service";
import type { DealCart } from "@/features/deals/types/dealCart.type";

type UseDealsCartOptions = { enabled?: boolean };

/**
 * Hook to fetch the deals cart using TanStack Query
 */
export const useDealsCart = (options?: UseDealsCartOptions) => {
  const { enabled = true } = options ?? {};

  return useQuery<DealCart>({
    queryKey: DEALS_CART_QUERY_KEY,
    queryFn: dealsCartService.getCart,
    enabled,
    staleTime: DEALS_CART_CACHE_CONFIG.staleTime,
    gcTime: DEALS_CART_CACHE_CONFIG.gcTime,
    refetchOnWindowFocus: DEALS_CART_CACHE_CONFIG.refetchOnWindowFocus,
  });
};
